import DeleteRecordButton from './DeleteRecordButton'

export default DeleteRecordButton
